(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

(function lockHomepageTouchToVerticalScroll() {
  function applyHomepageTouchLock() {
    if (!document.body?.classList.contains('template-index')) return;

    const styleId = 'bz-home-mobile-touch-lock';
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      @media (max-width: 900px) {
        html,
        body.template-index {
          width: 100%;
          max-width: 100%;
          overflow-x: hidden;
          overscroll-behavior-x: none;
          touch-action: pan-y pinch-zoom;
        }

        body.template-index #MainContent,
        body.template-index #MainContent > .shopify-section,
        body.template-index #MainContent .bz {
          width: 100%;
          max-width: 100%;
          min-width: 0;
          overflow-x: clip;
          touch-action: pan-y pinch-zoom;
        }

        body.template-index #MainContent .bz-wrap {
          width: 100%;
          max-width: 100%;
          min-width: 0;
          box-sizing: border-box;
        }
      }
    `;
    document.head.appendChild(style);

    document.documentElement.style.overflowX = 'hidden';
    document.documentElement.style.overscrollBehaviorX = 'none';
    document.documentElement.style.touchAction = 'pan-y pinch-zoom';
    document.body.style.overflowX = 'hidden';
    document.body.style.overscrollBehaviorX = 'none';
    document.body.style.touchAction = 'pan-y pinch-zoom';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHomepageTouchLock, { once: true });
  } else {
    applyHomepageTouchLock();
  }

  document.addEventListener('shopify:section:load', applyHomepageTouchLock);
})();